<template>
  <v-container>
    <m-card-list
      two-line
      title="Laporan Ketidakhadiran"
      :items="items"
      :headers="headers"
      :perPage="items.length"
      :filterDefault="false"
      select
      refresh
      @refresh="load"
      filterUser
      filterWaktu
      :btnDownload="isCan('presensi-rekap.download-ketidakhadiran')"
      @filter="filter"
      @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
      footer
      @toDownload="onDownloadList"
    >
      <template v-slot:info_filter>
        <v-chip v-if="currentPeriode" color="orange" outlined>
          <b>{{ currentPeriode.nama }}</b>&nbsp; {{ currentPeriode.tgl_mulai }} - {{ currentPeriode.tgl_selesai }}
        </v-chip>
      </template>
      <template v-slot:action_tools>
        <v-btn
          v-if="isCan('presensi-rekap.generate-ketidakhadiran') && filters.periode_laporan_id"
          color="orange"
          dark
          class="mx-1"
          @click="toGenerate"
        >
          <v-icon left>mdi-calculator</v-icon> Kalkulasi
        </v-btn>
      </template>
      <template v-slot:items="{ props, item }">
        <tr>
          <td>{{ pVal(item, 'nama') }}</td>
          <td>
                <span v-if="item.ketidakhadiran">
                  {{ item.ketidakhadiran.total_hari_hadir }}
                </span>
            <span v-else></span>
          </td>
          <td>
                <span v-if="item.ketidakhadiran">
                  {{ item.ketidakhadiran.total_tidak_hadir }}
                </span>
            <span v-else></span>
          </td>
          <td>
            <v-btn v-if="item.ketidakhadiran" color="primary" small depressed @click="onCheck(item)">
              <v-icon left>mdi-file-eye</v-icon> Periksa
            </v-btn>
          </td>
        </tr>
      </template>
    </m-card-list>

    <m-dialog ref="dlg" :btnsave="false" :fullscreen="false" title="Detail Ketidakhadiran">
      <v-container>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Nama
                </th>
                <th class="text-left">
                  Jumlah Hari
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in (detail && detail.tidak_hadir) || []" :key="item.name">
                <td>{{ item.nama }} ({{ item.singkat }})<br /></td>
                <td>{{ item.total }} hari</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </m-dialog>
  </v-container>
</template>

<script>
// import XLSX from "xlsx";

export default {
  data() {
    return {
      items: [],
      kategoris: [],
      filters: {},
      cp: 1,
      dialog: false,
      detail: {},
      periodeList: [],
    }
  },

  activated() {
    this.getKategori()
    this.fetchPeriode()
  },

  computed: {
    currentPeriode() {
      const current =
        this.periodeList.find((s) => +s.periode_laporan_id === Number(this.filters.periode_laporan_id)) || {}
      return this.filters.periode_laporan_id && Object.keys(current).length ? current : false
    },

    headers() {
      let temp = [
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: 'Total Hadir', align: 'left', value: 'total_hari_hadir' },
        {
          text: 'Total Tidak Hadir',
          align: 'left',
          value: 'total_tidak_hadir',
        },
        { text: '', align: 'left', value: '' },
      ]
      return temp
    },
  },

  methods: {
    load() {
      this.$store
        .dispatch('laporan/getKetidakhadiran', {
          organisasi_id: this.organisasi_id,
          params: Object.assign(
            {},
            {
              page: this.cp,
            },
            this.filters
          ),
        })
        .then(({ data }) => {
          this.items = (data && data.data) || []
        })
    },

    getKategori() {
      this.$store
        .dispatch('kategori/getAll', {
          organisasi_id: this.organisasi_id,
          params: { count: 100 },
        })
        .then(({ data }) => {
          this.kategoris = data || []
        })
    },

    filter(data) {
      if (data.dateRange) {
        this.$set(this.filters, 'periode_laporan_id', data.dateRange.periode_laporan_id)
      }
      this.load()
    },

    fetchPeriode() {
      const params = {
        organisasi_id: this.organisasi_id || this.$route.params.organisasi_id,
        params: {},
        is_all: true,
      }

      this.$store.dispatch('periode/getAll', params).then((res) => {
        this.periodeList = (res && res.data && res.data.data) || []
        const find = this.periodeList.find((s) => s.is_current_month === true) || {}
        const periode = Object.keys(find).length ? find : this.periodeList[0] || {}
        if (periode && periode.periode_laporan_id) {
          this.$set(this.filters, 'periode_laporan_id', periode.periode_laporan_id)
          this.load()
        }
      })
    },

    toGenerate() {
      this.$store
        .dispatch('laporan/generateTidakHadir', {
          organisasi_id: this.organisasi_id,
          params: this.filters,
        })
        .then(() => {
          this.load()
        })
    },

    onCheck(item) {
      this.detail = {}
      this.$set(this, 'detail', item.ketidakhadiran || {})

      this.$refs.dlg.open()
    },

    onDownloadList() {
      this.$store
        .dispatch('laporan/unduhKetidakhadiran', {
          organisasi_id: this.organisasi_id,
          params: this.filters,
        })
        .then((url) => {
          if (url) window.open(url)
        })
    },
  },
}
</script>
